import Popover from "@nt/dds-react/core/Popover";
import {Icon} from "../../../components";
import React from "react";
import {formatCurrency} from "../../../utils/format";
import {GeneralInflow} from "../../models/GeneralInflow";
import {SocialSecurity} from "../../models/SocialSecurity";
import {useAppSelector} from "../../../store/hooks";
import {selectReleaseToggles} from "../../../ReleaseToggles/releaseTogglesSlice";

export function FutureInflowsPopover(props: { futureInflow: GeneralInflow | SocialSecurity }) {
    const enableEnhancedLifestyleFunding = useAppSelector(selectReleaseToggles)?.enableEnhancedLifestyleFunding ?? false;
    return <>
        {
            props.futureInflow.isInflowWillFundLifestyleGoal &&
            <Popover
                id={`futureInflows-popover-${props.futureInflow.id}`}
                delay={0}
                content={
                    <div>
                        <div className="asset-summary-popover-content">
                            <span>Lifestyle Goal Aligned</span>
                            <span>{formatCurrency(props.futureInflow.lifestyleGoalAligned)}</span>
                        </div>
                        {enableEnhancedLifestyleFunding && (
                            <div className="asset-summary-popover-content">
                                <span>Non-Lifestyle Goal Aligned</span>
                                <span>{formatCurrency(props.futureInflow.nonLifestyleGoalAligned)}</span>
                            </div>
                        )}
                        <div className="asset-summary-popover-content">
                            <span>{enableEnhancedLifestyleFunding ? 'Savings' : 'Excess Inflow'}</span>
                            <span>{formatCurrency(props.futureInflow.excessFutureInflow)}</span>
                        </div>
                        {!enableEnhancedLifestyleFunding && (
                            <div className="asset-summary-popover-content">
                                <span>Inflow Reserve Years</span>
                                <span>{props.futureInflow.inflowReserveLength}</span>
                            </div>
                        )}
                        {!enableEnhancedLifestyleFunding && (
                            <div className="asset-summary-popover-content">
                                <span>Inflow Reserve Value</span>
                                <span>{formatCurrency(props.futureInflow.inflowReservePresentValue)}</span>
                            </div>
                        )}
                    </div>
                }
                direction="top"
                aria-label="futureInflows"
            >
                <Icon className="info-icon popover-trigger popoverContainer" ariaHidden={false}
                      name="status_info_outline" type="info" ariaLabel="inflow data"/>
            </Popover>
        }
    </>
}
